var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useParams } from "react-router";
import { SupportTicket } from "./support.ticket";
import { Link, useLocation } from "react-router-dom";
import "./support.css";
import { SupportTicketList } from "./support.ticket.list";
import { SupportFAQ } from "./support.faq";
import { SupportContact } from "./support.contact";
import { isMobile } from "../../App";
import { auth } from "../../store/auth.store";
import paths from "../../paths";
var subPages = {
    'cozum-merkezi': _jsx(SupportTicket, {}),
    'destek-taleplerim': _jsx(SupportTicketList, {}),
    'sikca-sorulan-sorular': _jsx(SupportFAQ, {}),
    'iletisim-bilgileri': _jsx(SupportContact, {}),
};
export function Support() {
    var param = useParams();
    if (param.page && subPages[param.page]) {
        return subPages[param.page];
    }
    return (_jsx(_Fragment, {}));
}
export function SupportMenu() {
    var pathname = useLocation().pathname;
    var menuItems = __spreadArray(__spreadArray([
        {
            path: "cozum-merkezi",
            label: "Çözüm Merkezi",
            shortLabel: "Çözüm",
            icon: ""
        }
    ], (auth.member && auth.member.id ? [{
            path: "destek-taleplerim",
            label: "Destek Taleplerim",
            shortLabel: "Taleplerim",
            icon: ""
        }] : []), true), [
        {
            path: "sikca-sorulan-sorular",
            label: "Sıkça Sorulan Sorular",
            shortLabel: "SSS",
            icon: ""
        },
        {
            path: "iletisim-bilgileri",
            label: "İletişim Bilgileri",
            shortLabel: "İletişim",
            icon: ""
        }
    ], false);
    return (_jsx("div", __assign({ className: "account-menu-container ".concat(isMobile ? 'account-menu-mobile' : '') }, { children: menuItems.map(function (item, index) {
            var isActive = pathname.includes(item.path);
            var isLast = index === menuItems.length - 1;
            return (_jsxs("div", __assign({ className: "account-menu-item" }, { children: [_jsx("div", { className: "account-menu-item-bg ".concat(isActive ? 'active' : ''), style: { borderBottom: isLast && !isMobile ? 'none' : '1px #F0F1F6 solid' } }), _jsxs(Link, __assign({ to: "".concat(paths.support.url, "/").concat(item.path, "/"), className: "account-menu-link" }, { children: [_jsx("div", __assign({ className: "account-menu-icon" }, { children: _jsx("span", __assign({ style: { fontSize: '16px' } }, { children: item.icon })) })), _jsx("div", __assign({ className: "account-menu-text ".concat(isActive ? 'active' : '') }, { children: isMobile ? item.shortLabel : item.label }))] }))] }), item.path));
        }) })));
}
